import React from "react";
import { SectionWrapper } from "../hoc";
import Card from "./Card";
import { features } from "../constants";
import { styles } from "../styles";
import { fadeIn } from "../utils/motion";
import { motion } from "motion/react";

const Features = () => {
  return (
    <div className=" font-lato">
      <motion.h2
        className={`mb-3 ${styles.sectionHeadText}`}
        variants={fadeIn("up", "spring", 0.5, 0.75)}
      >
        Features
      </motion.h2>
      <hr />
      <div className="flex flex-wrap justify-center gap-12 mt-16">
        {features.map((service, index) => (
          <Card
            index={index}
            title={service.title}
            paragraph={service.paragraph}
            icon={service.icon}
          />
        ))}
      </div>
    </div>
  );
};

export default SectionWrapper(Features, "features");
